import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import InstrumentsVM from './InstrumentsVM';
import { observer } from 'mobx-react';
import ManageInstrumentComponent from '../components/ManageInstrumentComponent';
import { TextConstants } from '../../../Common/TextConstants';
import InstrumentSearchLookup from '../../../DataInterception/InstrumentMapping/Models/InstrumentSearchLookup';
import Loading from '../../../App/Components/Loading/Loading';
import InstrumentTypesComponent from '../../InstrumentTypes/Views/InstrumentTypesView';
import { Instruments, InstrumentTypes } from '../../../AccessControl/Models/Commands/Security/Roles';

@observer
export default class InstrumentsView extends Views.ViewBase<InstrumentsVM> {

    constructor(props: unknown) {
        super("Instruments", InstrumentsVM, props);
    }

    public render() {
        return (
            <div>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                <Neo.TabContainer>
                    <Neo.Tab header="Instruments">
                        {this.viewModel.showManageInstrumentComponent &&
                            <ManageInstrumentComponent
                                viewModel={this.viewModel.manageInstrumentComponentVM}
                                onSave={() => this.viewModel.saveInstrument()}
                                onCancel={() => this.viewModel.cancelInstrument()} />
                        }

                        {this.viewModel.showManageInstrumentComponent === false &&
                            <Neo.Card title={TextConstants.Titles.Instruments} className="m-1">
                                {this.viewModel.authorisationService.hasRole(Instruments.AddNew) &&
                                    <div className="row pb-3">
                                        <div className="col text-right">
                                            <Neo.Button
                                                onClick={() => this.viewModel.displayManageInstrumentComponent()}
                                                variant="primary" size="sm"
                                            >{TextConstants.Buttons.AddInstrument}</Neo.Button>
                                        </div>
                                    </div>
                                }
                                <>
                                    <Neo.Form model={this.viewModel.instrumentSearchCriteria} onSubmit={() => this.viewModel.instrumentSearchCriteria.meta.searchCriteria.value === "" ? this.viewModel.instrumentsPageManager.refreshData() : this.viewModel.clearSearchInstrument()}>
                                        <Neo.FormGroup
                                            suppressLabel={true}
                                            bind={this.viewModel.instrumentSearchCriteria.meta.searchCriteria}
                                            placeholder={TextConstants.PlaceHolder.SearchInstrumentsCriteria}
                                            append={
                                                <Neo.Button className="btn-small" isSubmit variant="primary">
                                                    <i className={`${this.viewModel.instrumentSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                                </Neo.Button>}
                                        />
                                    </Neo.Form>
                                </>
                                <div>
                                    <Neo.Pager pageManager={this.viewModel.instrumentsPageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                        <div className="horizontalScroll inner-container">
                                            {this.viewModel.instrumentsPageManager.totalRecords > 0 &&
                                                <NeoGrid.Grid<InstrumentSearchLookup> className={"table-striped"}>
                                                    {(item, meta) => (
                                                        <NeoGrid.Row key={item.instrumentID}>
                                                            <NeoGrid.Column display={meta.description} label={TextConstants.Labels.InstrumentName} />
                                                            <NeoGrid.Column display={meta.instrumentType} />
                                                            <NeoGrid.Column display={meta.instrumentSubType} label={TextConstants.Labels.InstrumentSubType} />
                                                            <NeoGrid.Column display={meta.isin} label={TextConstants.Labels.Isin} />
                                                            <NeoGrid.Column display={meta.ticker} />
                                                            <NeoGrid.Column display={meta.isDualListed} label={TextConstants.Labels.DualListed} />
                                                            <NeoGrid.Column display={meta.isREIT} label={TextConstants.Labels.REIT} />
                                                            <NeoGrid.Column display={meta.isDeletedInd} label={TextConstants.Labels.Deleted} />
                                                            {this.viewModel.authorisationService.hasRole(Instruments.Edit) &&
                                                                <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                                    <Neo.Button
                                                                        onClick={() => this.viewModel.editInstrument(item)}
                                                                        variant="primary" isOutline className="btn-small"
                                                                    ><i className="fa fa-edit"></i></Neo.Button>
                                                                </NeoGrid.ButtonColumn>
                                                            }
                                                        </NeoGrid.Row>
                                                    )}
                                                </NeoGrid.Grid>
                                            }

                                            {this.viewModel.instrumentsPageManager.totalRecords === 0 &&
                                                <div className="col-md-12 p-0 text-center">
                                                    {TextConstants.GeneralText.NoRecords}
                                                </div>
                                            }
                                        </div>
                                    </Neo.Pager>
                                </div>
                            </Neo.Card>
                        }
                    </Neo.Tab>
                    {this.viewModel.authorisationService.hasRole(InstrumentTypes.Access) &&
                        <Neo.Tab header={TextConstants.Titles.InstrumentTypes}>
                            <InstrumentTypesComponent
                                viewModel={this.viewModel}
                            />
                        </Neo.Tab>
                    }
                </Neo.TabContainer>

            </div>
        );
    }
}